import { Search, Clock, Gem } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useNavigate, useParams } from "react-router-dom";

interface Category {
  name: string;
  post_count: number;
}

interface CategoryFilterProps {
  categories: Category[];
  activeCategory: string;
  className?: string;
}

export function CategoryFilter({ 
  categories, 
  activeCategory, 
  className 
}: CategoryFilterProps) {
  const navigate = useNavigate();
  const params = useParams();
  const currentTab = params.tab || 'pour-toi';
  
  // Sort categories by post count (descending) for left-to-right priority
  const sortedCategories = [...categories].sort((a, b) => b.post_count - a.post_count);

  const handleCategoryClick = (categoryName: string) => {
    navigate(`/bulletins/${currentTab}/${categoryName}`);
  };

  return (
    <div className={cn("flex items-center gap-2 overflow-x-auto scrollbar-hide pb-2", className)}>
      {/* Active categories sorted by popularity */}
      {sortedCategories.map((category) => (
        <Button
          key={category.name}
          variant={activeCategory === category.name ? "default" : "outline"}
          size="sm"
          onClick={() => handleCategoryClick(category.name)}
          className="whitespace-nowrap flex items-center gap-1.5 shrink-0 capitalize"
        >
          <Search className="h-3 w-3" />
          {category.name}
          <span className="text-xs opacity-70">({category.post_count})</span>
        </Button>
      ))}
    </div>
  );
}